// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import RankTier from "./rank_tier_type";


export default __t.object("DecayLog", {
  id: __t.u64(),
  userId: __t.u64(),
  appliedAt: __t.u64(),
  rpBefore: __t.i32(),
  rpAfter: __t.i32(),
  decayAmount: __t.i32(),
  get tier() {
    return RankTier;
  },
});


